/**
 * POC animated lobby — game open.
 * The pressed card does a quick press-scale + glow (one-shot class, Game.module.css), then the
 * EffectsLayer grows a light tunnel out of the card's rect. Fire-and-forget: it never delays or
 * blocks startGame, and both parts are finite, so a failed / locked start leaves nothing behind.
 */

import { effectsBus, FX_ENABLED, playOneShotClass } from 'shared/effects';

export const playGameOpenEffect = (card: HTMLElement | null): void => {
  if (!FX_ENABLED || !card) return;

  playOneShotClass(card, 'fx-press', 600);
  const { left, top, width, height } = card.getBoundingClientRect();
  effectsBus.play('gameOpen', { rect: { left, top, width, height } });
};
